// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"32a08028","629":"734d3a18","787":"b4d543ee","911":"58a3bd4a"}[chunkId] + ".chunk.js";
};